module.exports = __webpack_public_path__ + "img/c3-1.5c62a46d.jpg";